import "@/assets/js/nav-pills.js";
import "@/assets/scss/soft-ui-dashboard.scss";
import "@/assets/css/migps.css";

export default {
  install() {},
};
